<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="mapContainer">
    <div class="contenedor-init">
      <!-- <div
        class="tiempoestimado"
        v-if="Object.keys(caso).length > 0 && lat == 0 && lng == 0"
      >
        <h1>El usuario no ha ingresado al caso</h1>
      </div> -->
      <div
        class="tiempoestimado"
        v-show="tiempo_llegada_abogado || tiempo_llegada_investigador"
      >
        <h1 v-if="tiempo_llegada_abogado">
          {{ tiempo_llegada_abogado }}
        </h1>
        <h1 v-if="tiempo_llegada_investigador">
          {{ !llegada ? tiempo_llegada_investigador : llegada }}
        </h1>
      </div>
      <v-btn
        v-if="cargo == 'Abogado' && !this.uidabogado"
        class="btnTomarCaso"
        @click="btnTomarCasoAbogado"
        color="secondary"
        elevation="2"
        :disabled="loading"
        :loading="loading"
        small
        >Tomar caso</v-btn
      >

      <v-btn
        v-if="cargo == 'Investigador' && !this.uidinvestigador"
        class="btnTomarCaso"
        @click="btnTomarCasoInvestigador"
        color="secondary"
        elevation="2"
        :disabled="loading"
        :loading="loading"
        small
        >Tomar caso</v-btn
      >

      <v-btn
        v-if="cargo == 'Investigador' && this.uidinvestigador && !this.llegada"
        class="btnTomarCaso"
        @click="btnLlegada"
        color="secondary"
        elevation="2"
        :disabled="loading"
        :loading="loading"
        small
        >LLegada al sitio</v-btn
      >
      <v-row v-if="direccion" class="content-direccion">
        <p>Dirección: {{ direccion }}</p>
      </v-row>
    </div>
    <GmapMap
      :options="options"
      :center="localizacion"
      :zoom="15"
      style="width: 100%; height: inherit"
      map-type-id="roadmap"
    >
      <!-- <GmapMarker :position="localizacion" /> -->
      <gmap-marker
        :key="index"
        v-for="(gmp, index) in localizaciones"
        :position="gmp"
        :clickable="true"
        :icon="gmp.icon"
        :label="gmp.label"
        :draggable="false"
        @click="openInfoWindowTemplate(index)"
      >
        <gmap-info-window
          :options="{
            maxWidth: 300,
            pixelOffset: { width: 0, height: -35 },
          }"
          :position="infoWindow.position"
          :opened="infoWindow.open"
          @closeclick="infoWindow.open = false"
        >
          <div v-html="infoWindow.template"></div>
        </gmap-info-window>
      </gmap-marker>
      <DirectionsRenderer
        travelMode="DRIVING"
        :origin="startLocation"
        :destination="endLocation"
      ></DirectionsRenderer>
    </GmapMap>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapState, mapActions } from "vuex";
import { db } from "../../firebase";
import imgCliente from "../../assets/google-map/cliente.png";
import imgAbogado from "../../assets/google-map/abogado.png";
import imgInvestigador from "../../assets/google-map/investigador.png";
import DirectionsRenderer from "@/pages/Maps/DirectionsRenderer";
// import { styleMap } from "@/pages/Maps/StyleMaps"; // Archivo de estilos

export default {
  name: "MapGogle",
  components: {
    DirectionsRenderer, // Pinta la ruta entre el investigador y cliente en el mapa
  },
  data() {
    return {
      lat: 0,
      lng: 0,
      id: "",
      latAb: 0,
      lngAb: 0,
      latIn: 0,
      lngIn: 0,
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      uidabogado: null,
      uidinvestigador: null,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
        // styles: styleMap,
      },
      loading: false,
      caso: {},
      tiempo_llegada_abogado: null,
      tiempo_llegada_investigador: null,
      msjAbg: "",
      msjInv: "",
      nombre_inv: "",
      telefono_inv: "",
      nombre_abg: "",
      telefono_abg: "",
      nombre_cli: "",
      telefono_cli: "",
      llegada: "",
      registration_ids: [],
      title: "",
      message: "",
      descripcion_trazabilidad: "",
      usuario: "",
      titulo: "",
      msj: "",
      url: "",
      cargos: [],
      token_cliente: "",
      token_contac: "",
      estadoUsuarioLogueado: "",
      campo: "",
      address: "Cra. 8 E #11-03, Santa Ana, Magdalena",
      latitud: null,
      longitud: null,
      direccion: "",
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    cargo: {
      get() {
        return `${this.logueado.cargo}`;
      },
    },
    localizacion() {
      if (this.lat !== 0 && this.lng !== 0) {
        return { lat: this.lat, lng: this.lng };
      } else if (this.latAb && this.lngAb) {
        return { lat: this.latAb, lng: this.lngAb };
      } else if (this.latIn && this.lngIn) {
        return { lat: this.latIn, lng: this.lngIn };
      } else {
        return { lat: this.lat, lng: this.lng };
      }
    },
    localizaciones() {
      let info = [];
      if (this.lat !== 0 && this.lng !== 0) {
        info = [
          {
            lat: this.lat,
            lng: this.lng,
            icon: {
              url: imgCliente,
              scaledSize: { width: 40, height: 40 },
              labelOrigin: { x: 16, y: -10 },
            },
            label: {
              text: "Cliente",
              color: "black",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
        ];
      }

      if (this.latAb !== 0 && this.lngAb !== 0) {
        info = [
          ...info,
          {
            lat: this.latAb,
            lng: this.lngAb,
            icon: {
              url: imgAbogado,
              scaledSize: { width: 40, height: 40 },
              labelOrigin: { x: 16, y: -10 },
            },
            label: {
              text: "Abogado",
              color: "black",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
        ];
        this.TiempoLlegadaAbogado();
      }

      if (this.latIn !== 0 && this.lngIn !== 0) {
        info = [
          ...info,
          {
            lat: this.latIn,
            lng: this.lngIn,
            icon: {
              url: imgInvestigador,
              scaledSize: { width: 40, height: 40 },
              labelOrigin: { x: 16, y: -10 },
            },
            label: {
              text: "Investigador",
              color: "black",
              fontWeight: "bold",
              fontSize: "16px",
            },
          },
        ];
        this.TiempoLlegadaInvestigador();
      }
      return info;
    },
    startLocation() {
      return {
        lat: this.latIn,
        lng: this.lngIn,
      };
    },
    endLocation() {
      return {
        lat: this.lat,
        lng: this.lng,
      };
    },
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    ...mapActions("trazabilidad", ["trazabilidadEstadoUsuarios"]),
    async infoCliente() {
      const objCaso = await db.collection("casos").doc(this.id).get();
      // console.log({ cliente: objCaso.data().uidconductor });
      const { uidconductor } = objCaso.data();
      if (uidconductor) {
        const objCliente = await db
          .collection("clientes")
          .doc(uidconductor)
          .get();
        const { nombres, apellidos, telefono, tokenPush } = objCliente.data();
        this.nombre_cli = `${nombres} ${apellidos}`;
        this.telefono_cli = telefono;
        if (tokenPush) {
          this.token_cliente = tokenPush;
        }
      }
    },
    async infoAsesor() {
      const objCaso = await db.collection("casos").doc(this.id).get();
      // console.log({ contac: objCaso.data().uidcontactcenter });
      const { uidcontactcenter } = objCaso.data();
      if (uidcontactcenter) {
        const objAsesor = await db
          .collection("usuarios")
          .doc(uidcontactcenter)
          .get();
        const { tokenPush: token } = objAsesor.data();
        if (token) {
          this.token_contac = token;
        }
      }
    },
    init() {
      db.collection("casos")
        .doc(this.id)
        .onSnapshot((snap) => {
          this.llegada = snap.data().llegada
            ? "Investigador llego al sitio"
            : "";
          this.caso = snap.data();
          this.tiempo_llegada_abogado = snap.data().tiempo_llegada_abogado;
          this.tiempo_llegada_investigador =
            snap.data().tiempo_llegada_investigador;
          this.lat = snap.data().localizacion
            ? snap.data().localizacion._lat
            : 0;
          this.lng = snap.data().localizacion
            ? snap.data().localizacion._long
            : 0;
          if (
            this.caso.origen_desde === "Cronos" &&
            this.lng == 0 &&
            this.lat == 0
          ) {
            //obtener las coordenadas por medio de la dirección
            this.address =
              this.caso.direccion_siniestro + "," + this.caso.ciudad_siniestro;
            this.getCoordinates();
          }
        });
    },
    async ubicaciones() {
      // let identificaciones = [];
      try {
        const objCaso = await db.collection("casos").doc(this.id).get();
        const {
          uidabogado,
          uidinvestigador,
          direccion_siniestro: direccion,
        } = objCaso.data();
        this.direccion = direccion;
        // INFO ABOGADO
        if (uidabogado) {
          await db
            .collection("usuarios")
            .doc(uidabogado)
            .onSnapshot((doc) => {
              this.latAb = doc.data().lat ? doc.data().lat : 0;
              this.lngAb = doc.data().long ? doc.data().long : 0;
              this.nombre_abg = `${doc.data().nombres} ${doc.data().apellidos}`;
            });

          // const objAbogado = await db
          //   .collection("usuarios")
          //   .doc(uidabogado)
          //   .get();
          // const _abogado = objAbogado.data();
          // if (_abogado) {
          //   this.latAb = _abogado.lat ? _abogado.lat : 0;
          //   this.lngAb = _abogado.long ? _abogado.long : 0;
          // eslint-disable-next-line no-const-assign
          // identificaciones = [...identificaciones, _abogado.identificacion];
          //}
        }

        //INFO INVESTIGADOR
        if (uidinvestigador) {
          await db
            .collection("usuarios")
            .doc(uidinvestigador)
            .onSnapshot((doc) => {
              this.latIn = doc.data().lat ? doc.data().lat : 0;
              this.lngIn = doc.data().long ? doc.data().long : 0;
              this.nombre_inv = `${doc.data().nombres} ${doc.data().apellidos}`;
            });

          // const objInvestigador = await db
          //   .collection("usuarios")
          //   .doc(uidinvestigador)
          //   .get();
          // const _investigador = objInvestigador.data();
          // console.log(_investigador);
          // if (_investigador) {
          //   this.latIn = _investigador.lat ? _investigador.lat : 0;
          //   this.lngIn = _investigador.long ? _investigador.long : 0;
          //   // eslint-disable-next-line no-const-assign
          //   // identificaciones = [
          //   //   ...identificaciones,
          //   //   _investigador.identificacion,
          //   // ];
          // }

          //TODO: INFO CLIENTE
          // if (identificaciones.length <= 0) {
          //   return;
          // }
          // db.collection("usuarios")
          //   .where("identificacion", "in", identificaciones)
          //   .onSnapshot((snap) => {
          //     const usuarios = snap.docs.map((e) => e.data());
          //     usuarios.forEach((e) => {
          //       if (e.cargo == "Abogado") {
          //         this.latAb = e.lat ? e.lat : 0;
          //         this.lngAb = e.long ? e.long : 0;
          //       }
          //       if (e.cargo == "Investigador") {
          //         this.latIn = e.lat ? e.lat : 0;
          //         this.lngIn = e.long ? e.long : 0;
          //       }
          //     });
          //   });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async openInfoWindowTemplate(index) {
      let info = "";
      let staddress = "";
      const { lat, lng, label } = this.localizaciones[index];
      const position = new window.google.maps.LatLng(lat, lng);
      const geocoder = new window.google.maps.Geocoder();
      await geocoder.geocode({ latLng: position }, function (results, status) {
        if (status == "OK") {
          const { formatted_address } = results[0];
          staddress = formatted_address;
        } else {
          console.log(
            "Geocode was not successful for the following reason: " + status
          );
        }
      });

      if (label.text === "Cliente") {
        info = `<b>Cliente: </b>${this.nombre_cli} <br>
                    <b>Teléfono: </b>${this.telefono_cli} </br>
                    <b>Dirección: </b>${staddress} </br>`;
      } else if (label.text === "Investigador") {
        info = `<b>Investigador: </b>${this.nombre_inv} <br>
                ${
                  this.tiempo_llegada_investigador
                    ? `<b>${this.tiempo_llegada_investigador}</b>`
                    : ""
                }</br>`;
      } else {
        info = `<b>Abogado: </b>${this.nombre_abg} <br>
                    ${
                      this.tiempo_llegada_abogado
                        ? `<b>${this.tiempo_llegada_abogado}</b>`
                        : ""
                    }</br>`;
      }
      this.infoWindow.position = { lat: lat, lng: lng };
      this.infoWindow.template = info;
      this.infoWindow.open = true;
    },
    async asignado() {
      // para abogado o investigador
      try {
        db.collection("casos")
          .doc(this.id)
          .onSnapshot((snap) => {
            const { uidabogado, uidinvestigador } = snap.data();
            this.uidabogado = uidabogado;
            this.uidinvestigador = uidinvestigador;
          });
      } catch (error) {
        console.log(error);
      }
    },
    async btnTomarCasoAbogado() {
      try {
        this.campo = "uidabogado";
        this.loading = true;
        this.title = "CASO ASIGNADO";
        this.msj = `EL ${this.logueado?.cargo?.toUpperCase()} ${
          this.usuario
        } HA SIDO ASIGNADO AL CASO #${this.caso.caso}.`;
        await db.collection("casos").doc(this.id).update({
          uidabogado: this.logueado.id,
          // Registrar fecha/hora de asignación sin importar el origen del flujo
          horadeasignacion: new Date(),
        });
        this.descripcion_trazabilidad = `Se ha asignado un abogado.`;
        await this.trazabilidad();
        await this.updateEstadoUsuario();
        await this.consultarTokens();
        this.ubicaciones();
        this.handleSuccess({ message: "CASO ASIGNADO" });
        // Se envían las notificaciones
        await this.EnviarNotificaciones({
          registration_ids: this.registration_ids,
          title: this.title,
          message: this.msj,
          url: this.url,
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateEstadoUsuario() {
      db.collection("casos")
        .where(this.campo, "==", this.logueado.id)
        .where("archivado", "==", false)
        .get()
        .then((res) => {
          this.estadoUsuarioLogueado =
            res.size > 1 ? "Activo multiple" : "Activo ocupado";
          // se actualiza el estado del usuario logueado
          db.collection("usuarios")
            .doc(this.logueado.id)
            .update({ disponibilidad: this.estadoUsuarioLogueado })
            .then(() => {
              this.$store.dispatch("updatePerfilLogueado", {
                id: this.logueado.id,
              });
              this.trazabilidadEstadoUsuarios({
                descripcion: this.msj,
                estado: this.estadoUsuarioLogueado,
                uidcaso: this.id,
                cargo: this.logueado.cargo,
                uidcreador: this.logueado.id,
                uidusuario: this.logueado.id,
              });
            });
        });
    },
    async btnTomarCasoInvestigador() {
      try {
        this.campo = "uidinvestigador";
        this.loading = true;
        this.title = "CASO ASIGNADO";
        this.msj = `EL ${this.logueado?.cargo?.toUpperCase()} ${
          this.usuario
        } HA SIDO ASIGNADO AL CASO #${this.caso.caso}.`;
        await db.collection("casos").doc(this.id).update({
          uidinvestigador: this.logueado.id,
          // Registrar fecha/hora de asignación sin importar el origen del flujo
          horadeasignacion: new Date(),
        });
        this.descripcion_trazabilidad = `Se ha asignado un investigador.`;
        await this.trazabilidad();
        await this.updateEstadoUsuario();
        await this.consultarTokens();
        this.ubicaciones();
        this.handleSuccess({ message: "CASO ASIGNADO" });
        await this.EnviarNotificaciones({
          registration_ids: this.registration_ids,
          title: this.title,
          message: this.msj,
          url: this.url,
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async consultarTokens() {
      try {
        const usuarios = await db
          .collection("usuarios")
          .where("cargo", "in", this.cargos)
          .get();

        const objUsuNotificar = usuarios.docs.map((e) => ({
          ...e.data(),
        }));

        const usu = objUsuNotificar
          .filter((e) => {
            return e.tokenPush;
          })
          .map((u) => {
            return u.tokenPush;
          });
        if (usu.length > 0) {
          this.registration_ids = [
            ...usu,
            this.token_cliente,
            this.token_contac,
          ];
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleSuccess({ message }) {
      this.$swal({
        icon: "success",
        title: "OPERACIÓN EXITOSA.",
        text: message,
      });
      this.loading = false;
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async TiempoLlegadaAbogado() {
      //console.log("TiempoLlegadaAbogado");
      // console.log({ lat: this.lat, lng: this.lng });
      // eslint-disable-next-line no-undef
      const service = new google.maps.DistanceMatrixService();
      const request = {
        origins: [{ lat: this.latAb, lng: this.lngAb }],
        destinations: [{ lat: this.lat, lng: this.lng }],
        travelMode: "DRIVING",
        avoidHighways: false,
        avoidTolls: false,
      };
      service
        .getDistanceMatrix(request)
        .then((response) => {
          const rows = response.rows[0].elements[0];
          if (rows.status == "ZERO_RESULTS") {
            return;
          }
          if (rows.duration.value > 0) {
            let msj = `Tiempo estimado de llegada del abogado ${rows.duration.text}`;
            this.TiempoEstimadoAbogado(msj);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async TiempoLlegadaInvestigador() {
      // eslint-disable-next-line no-undef
      const service = new google.maps.DistanceMatrixService();
      const request = {
        origins: [{ lat: this.latIn, lng: this.lngIn }],
        destinations: [{ lat: this.lat, lng: this.lng }],
        travelMode: "DRIVING",
        avoidHighways: false,
        avoidTolls: false,
      };
      service
        .getDistanceMatrix(request)
        .then((response) => {
          const rows = response.rows[0].elements[0];
          if (rows.status == "ZERO_RESULTS") {
            return;
          }
          if (rows.duration.value > 0) {
            this.msjInv = `Tiempo estimado de llegada del investigador ${rows.duration.text}`;
            this.TiempoEstimadoInvestigador();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    TiempoEstimadoAbogado(msj) {
      db.collection("casos")
        .doc(this.id)
        .update({
          tiempo_llegada_abogado: msj,
        })
        .then(() => {
          // this.tiempo_llegada_abogado = msj;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    TiempoEstimadoInvestigador() {
      // console.log("actualizar", this.id);
      db.collection("casos")
        .doc(this.id)
        .update({
          tiempo_llegada_investigador: this.msjInv,
        })
        .then(console.log("UPDATE LLEGADA INV"))
        .catch((e) => {
          console.log(e);
        });
    },
    async btnLlegada() {
      moment.tz.setDefault("America/Bogota");
      const confirm = await this.$swal({
        title: "¿Quieres marcar la llegada al sitio?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
      });

      if (confirm.isConfirmed) {
        try {
          const identification =
            this.logueado.identificacion ||
            JSON.parse(localStorage.getItem("logueado")).identificacion;
          await db.collection("casos").doc(this.id).update({ llegada: true });
          this.descripcion_trazabilidad = `El investigador ha llegado al sitio.`;
          await this.trazabilidad();
          await this.consultarTokens();
          //Notificar
          const fechaActual = moment().format("YYYY-MM-DD HH:mm:ss");
          await db.collection("notificaciones").add({
            cedula: identification,
            caso: this.caso.caso,
            momento: "Llegada al sitio",
            fechahora: fechaActual,
          });
          this.llegada = "Investigador llego al sitio";
          this.title = "LLEGADA DEL INVESTIGADOR";
          this.message = `EL INVESTIGADOR LLEGO AL SITIO, CASO # ${this.caso.caso}`;
          this.registration_ids.length > 0 &&
            (await this.EnviarNotificaciones({
              registration_ids: this.registration_ids,
              title: this.title,
              message: this.message,
              url: this.url,
            }));
        } catch (error) {
          console.log(error);
        }
      }
    },
    async trazabilidad() {
      await db.collection("trazabilidad").add({
        descripcion: this.descripcion_trazabilidad,
        fechahora: Date.now(),
        uidcaso: this.id,
      });
    },
    getCoordinates() {
      // const url = `https://geocode.xyz/${encodeURIComponent(
      //   this.address
      // )}?json=1`;
      // fetch(url)
      //   .then((response) => response.json())
      //   .then((data) => {
      //     console.log(data);
      //     if (data.latt && data.longt) {
      //       const latitude = data.latt;
      //       const longitude = data.longt;
      //       console.log("Latitud:", latitude);
      //       console.log("Longitud:", longitude);
      //     } else {
      //       console.error(
      //         "No se encontraron coordenadas para la dirección proporcionada."
      //       );
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error al obtener las coordenadas:", error);
      //   });
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: this.address }, (results, status) => {
        if (status === "OK") {
          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          db.collection("casos")
            .doc(this.id)
            .update({
              localizacion: { _lat: this.latitude, _long: this.longitude },
            });
        } else {
          console.error(
            "Verifique la direction del caso, Google no tuvo éxito por la siguiente razón:",
            status
          );
        }
      });
    },
  },
  async created() {
    this.id = this.$route.params.id;
    await this.infoCliente();
    await this.infoAsesor();
    this.init();
    await this.asignado();
    if (this.logueado.cargo === "Abogado") {
      this.cargos = ["Coordinador Contact Center", "Coordinador Abogado"];
    }
    if (this.logueado.cargo === "Investigador") {
      this.cargos = ["Coordinador Contact Center", "Coordinador Investigador"];
    }
    this.usuario = `${this.logueado?.nombres?.toUpperCase()} ${this.logueado?.apellidos?.toUpperCase()}`;
    this.url = `https://digipats.com.co/gestionar-caso/${this.id}`;
  },
  mounted() {
    this.ubicaciones();
  },
};
</script>

<style src="./Google.scss" lang="scss" scoped />
